import { RoleConfig } from '../../../types';

export const DriveRoles = {
  ViewDriveExplorer: {
    name: 'Can View Drive Explorer',
    value: 'viewDriveExplorer',
    type: 'view',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanViewDriveLabels: {
    name: 'Can View Drive Labels',
    value: 'canViewDriveLabels',
    type: 'view',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  CanRemoveDriveLabels: {
    name: 'Can Remove Drive Labels',
    value: 'bulkRemoveDriveLabels',
    type: 'update',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CreateDriveLabels: {
    name: 'Create Drive Labels',
    value: 'createLabels',
    type: 'create',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DeleteDriveLabels: {
    name: 'Delete Drive Labels',
    value: 'deleteLabels',
    type: 'delete',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  UpdateDriveLabelsStatus: {
    name: 'Enable/Disable Drive Labels',
    value: 'updateDriveLabelsStatus',
    type: 'update',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditDriveLabels: {
    name: 'Edit Drive Labels',
    value: 'editLabels',
    type: 'update',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanViewDocuments: {
    name: 'Can View Documents',
    value: 'canViewDocuments',
    type: 'view',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  CanCreateFolders: {
    name: 'Can Create Folders',
    value: 'canCreateFolders',
    type: 'create',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanMoveDocs: {
    name: 'Can Move Docs',
    value: 'canMoveDocs',
    type: 'update',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanTrashDocs: {
    name: 'Can Trash Docs',
    value: 'canTrashDocs',
    type: 'delete',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanRestoreDocs: {
    name: 'Can Restore Docs',
    value: 'canRestoreDocs',
    type: 'update',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanDeleteDocs: {
    name: 'Can Delete Docs',
    value: 'canDeleteDocs',
    type: 'delete',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanRenameDocs: {
    name: 'Can Rename Docs',
    value: 'canRenameDocs',
    type: 'update',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanStarDocs: {
    name: 'Can Star Docs',
    value: 'canStarDocs',
    type: 'update',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanCopyDocs: {
    name: 'Can Copy Docs',
    value: 'canCopyDocs',
    type: 'update',
    group: 'drive',
    currentlyUsed: false,
    hasChangeLog: true,
  },
  CanAddShortcuts: {
    name: 'Can Add Shortcuts',
    value: 'canAddShortcuts',
    type: 'create',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanTransferDocs: {
    name: 'Can Transfer Docs',
    value: 'canTransferDocs',
    type: 'update',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanShareDocs: {
    name: 'Can Share Docs',
    value: 'canShareDocs',
    type: 'update',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanEditDocVisibility: {
    name: 'Can Edit Doc Visibility',
    value: 'canEditDocVisibility',
    type: 'update',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanEditDocShares: {
    name: 'Can Edit Doc Shares',
    value: 'canEditDocShares',
    type: 'update',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewSharedDrives: {
    name: 'View Shared Drives',
    value: 'viewSharedDrives',
    type: 'view',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanCopyShareDriveID: {
    name: 'Can Copy Share Drive ID',
    value: 'canCopyShareDriveID',
    type: 'update',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanUpdateSharedDrivePermissions: {
    name: 'Can Update Shared Drive Permissions',
    value: 'canUpdateSharedDrivePermissions',
    type: 'update',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanUpdateSharedDriveSettings: {
    name: 'Can Update Shared Drive Settings',
    value: 'canUpdateSharedDriveSettings',
    type: 'update',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanRenameSharedDrives: {
    name: 'Can Rename Shared Drives',
    value: 'canRenameSharedDrives',
    type: 'update',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanDeleteSharedDrives: {
    name: 'Can Delete Shared Drives',
    value: 'canDeleteSharedDrives',
    type: 'delete',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewOwnershipTransferLogs: {
    name: 'View Ownership Transfer Logs',
    value: 'viewOwnershipTransferLogs',
    type: 'view',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  ViewDriveSweep: {
    name: 'View Drive Sweep',
    value: 'viewDriveSweep',
    type: 'view',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  CanDeleteDriveSweep: {
    name: 'Can Delete Drive Sweep',
    value: 'canDeleteDriveSweep',
    type: 'delete',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanCreateDriveSweep: {
    name: 'Can Create Drive Sweep',
    value: 'canCreateDriveSweep',
    type: 'create',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanStartDriveSweep: {
    name: 'Can Start Drive Sweep',
    value: 'canStartDriveSweep',
    type: 'start',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewDriveSearch: {
    name: 'View Drive Search',
    value: 'viewDriveSearch',
    type: 'view',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanExportDriveSearch: {
    name: 'Export Drive Search',
    value: 'canExport',
    type: 'create',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanEditDriveSweep: {
    name: 'Can Edit Drive Sweep',
    value: 'canEditDriveSweep',
    type: 'update',
    group: 'drive',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanCreateSharedDrives: {
    name: 'Create Shared Drives',
    value: 'canCreateSharedDrives',
    type: 'create',
    group: 'drive',
    currentlyUsed: false,
    hasChangeLog: true,
  },
  UpdateDriveSweepStatus: {
    name: 'Enable/Disable Drive Sweep',
    value: 'updateDriveSweepStatus',
    type: 'update',
    group: 'drive',
    currentlyUsed: false,
    hasChangeLog: true,
  },
};

export const AdministrationRoles = {
  ViewAppLogs: {
    name: 'View App Logs',
    value: 'viewAppLogs',
    type: 'view',
    group: 'administration',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  ExportAppLogs: {
    name: 'Export App Logs',
    value: 'exportAppLogs',
    type: 'create',
    group: 'administration',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewRoles: {
    name: 'View Roles',
    value: 'viewRoles',
    type: 'view',
    group: 'administration',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  ViewSettings: {
    name: 'View Settings',
    value: 'viewSettings',
    type: 'view',
    group: 'administration',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  ViewLabs: {
    name: 'View Labs',
    value: 'viewLabs',
    type: 'view',
    group: 'administration',
    currentlyUsed: false,
    hasChangeLog: false,
  },
  CreateRole: {
    name: 'Create Role',
    value: 'createRole',
    type: 'create',
    group: 'administration',
    currentlyUsed: false,
    hasChangeLog: true,
  },
  DeleteRole: {
    name: 'Delete Role',
    value: 'deleteRole',
    type: 'delete',
    group: 'administration',
    currentlyUsed: false,
    hasChangeLog: true,
  },
  EditRole: {
    name: 'Edit Role',
    value: 'editRole',
    type: 'update',
    group: 'administration',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RenameRole: {
    name: 'Rename Role',
    value: 'renameRole',
    type: 'update',
    group: 'administration',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  AddMemberToRole: {
    name: 'Add Member to Role',
    value: 'addMemberToRole',
    type: 'update',
    group: 'administration',
    currentlyUsed: false,
    hasChangeLog: true,
  },
  RemoveMemberFromRole: {
    name: 'Remove Member from Role',
    value: 'removeMemberFromRole',
    type: 'delete',
    group: 'administration',
    currentlyUsed: false,
    hasChangeLog: true,
  },
  ViewDomainDefaultResourceCalendar: {
    name: 'View Domain Default for Resource Calendar',
    value: 'viewDomainDefaultResourceCalendar',
    type: 'view',
    group: 'administration',
    currentlyUsed: false,
    hasChangeLog: false,
  },
  ViewSetGpanelAdmin: {
    name: 'Can View gPanel Admin',
    value: 'viewSetGpanelAdmin',
    type: 'view',
    group: 'administration',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  UpdateGpanelAdmin: {
    name: 'Update gPanel Admin',
    value: 'updateGpanelAdmin',
    type: 'updated',
    group: 'administration',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewIndexing: {
    name: 'View Indexing',
    value: 'viewIndexing',
    type: 'view',
    group: 'administration',
    currentlyUsed: false,
    hasChangeLog: false,
  },
  ViewIpIntrusion: {
    name: 'View IP Intrusion',
    value: 'viewIpIntrusion',
    type: 'view',
    group: 'administration',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  CreateIpIntrusionEntity: {
    name: 'Create IP Intrusion User/IP Address',
    value: 'createIpIntrusionEntity',
    type: 'create',
    group: 'administration',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DeleteIpIntrusionEntity: {
    name: 'Delete IP Intrusion User/IP Address',
    value: 'deleteIpIntrusionEntity',
    type: 'delete',
    group: 'administration',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  UpdateIpIntrusionStatus: {
    name: 'Can enable/disable IP Intrusion',
    value: 'updateIpIntrusionStatus',
    type: 'update',
    group: 'administration',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  updateApiIpIntrusionStatus: {
    name: 'Can enable/disable API IP Intrusion',
    value: 'updateApiIpIntrusionStatus',
    type: 'update',
    group: 'administration',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewSecondaryDomains: {
    name: 'Can View Secondary Domains',
    value: 'viewSecondaryDomains',
    type: 'view',
    group: 'administration',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  UpdateSecondaryDomains: {
    name: 'Edit Secondary Domains',
    value: 'updateSecondaryDomains',
    type: 'update',
    group: 'administration',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewTimezone: {
    name: 'Can View Timezone',
    value: 'viewTimezone',
    type: 'view',
    group: 'administration',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  UpdateTimezone: {
    name: 'Update Timezone',
    value: 'updateTimezone',
    type: 'update',
    group: 'administration',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewSlackIntegration: {
    name: 'Can View Slack integration',
    value: 'viewSlackIntegration',
    type: 'view',
    group: 'administration',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  UpdateSlackIntegration: {
    name: 'Can update Slack integration',
    value: 'updateSlackIntegration',
    type: 'update',
    group: 'administration',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewCustomLabeling: {
    name: 'Can View Custom Labeling',
    value: 'viewCustomLabeling',
    type: 'view',
    group: 'administration',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  ViewLabelsManager: {
    name: 'Can View Label Manager',
    value: 'viewLabelsManager',
    type: 'view',
    group: 'administration',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  UpdateCustomLabeling: {
    name: 'Update Custom Labeling',
    value: 'updateCustomLabeling',
    type: 'update',
    group: 'administration',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewGoogleApiStatus: {
    name: 'Can View Google API Status',
    value: 'viewGoogleApiStatus',
    type: 'view',
    group: 'administration',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  TurnLabsOnOff: {
    name: 'Enable/Disable Lab Features',
    value: 'turnLabsOnOff',
    type: 'update',
    group: 'administration',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  GetGoogleApiStatusNotifications: {
    name: 'Get Google API Status Notifications',
    value: 'canGetGoogleApiStatusNotifications',
    type: 'view',
    group: 'administration',
    currentlyUsed: false,
    hasChangeLog: false,
  },
  AccessDs: {
    name: 'Access gPanel Data Security',
    value: 'canAccessDs',
    type: 'view',
    group: 'administration',
    currentlyUsed: false,
    hasChangeLog: false,
  },
  EnableEmailNotificationOutsideDomain: {
    name: 'Enable email notification outside domain',
    value: 'canenableEmailNotificationOutsideDomain',
    type: 'view',
    group: 'administration',
    currentlyUsed: false,
    hasChangeLog: false,
  },
  ViewSessionTimeout: {
    name: 'View Session Timeout',
    value: 'viewSessionTimeout',
    type: 'view',
    group: 'administration',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  UpdateSessionTimeout: {
    name: 'Update Session Timeout',
    value: 'updateSessionTimeout',
    type: 'update',
    group: 'administration',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewWelcomeTemplates: {
    name: 'View Welcome Email Templates',
    value: 'viewWelcomeTemplates',
    type: 'view',
    group: 'administration',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  ViewApiLogs: {
    name: 'View gPanel API Logs',
    value: 'viewApiLogs',
    type: 'view',
    group: 'administration',
    currentlyUsed: false,
    hasChangeLog: false,
  },
  ViewApiKeys: {
    name: 'View gPanel API Key',
    value: 'viewApiKeys',
    type: 'view',
    group: 'administration',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  DeleteApiKeys: {
    name: 'Delete API Keys',
    value: 'deleteApiKeys',
    type: 'delete',
    group: 'administration',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CreateApiKeys: {
    name: 'Create API Keys',
    value: 'createApiKeys',
    type: 'create',
    group: 'administration',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DeleteWelcomeTemplate: {
    name: 'Delete Welcome Template',
    value: 'deleteWelcomeTemplate',
    type: 'delete',
    group: 'administration',
    currentlyUsed: false,
    hasChangeLog: true,
  },
  EditWelcomeTemplate: {
    name: 'Edit Welcome Template',
    value: 'editWelcomeTemplate',
    type: 'update',
    group: 'administration',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CreateWelcomeTemplates: {
    name: 'Create Welcome Template',
    value: 'createWelcomeTemplates',
    type: 'create',
    group: 'administration',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunUserIndexing: {
    name: 'Run User Indexing',
    value: 'runUserIndexing',
    type: 'create',
    group: 'administration',
    currentlyUsed: false,
    hasChangeLog: true,
  },
  RunOrgIndexing: {
    name: 'Run OrgUnit Indexing',
    value: 'runOrgIndexing',
    type: 'create',
    group: 'administration',
    currentlyUsed: false,
    hasChangeLog: true,
  },
  RunGroupIndexing: {
    name: 'Run Group Indexing',
    value: 'runGroupIndexing',
    type: 'create',
    group: 'administration',
    currentlyUsed: false,
    hasChangeLog: true,
  },
  RunCalendarIndexing: {
    name: 'Run Calendar Indexing',
    value: 'runCalendarIndexing',
    type: 'create',
    group: 'administration',
    currentlyUsed: false,
    hasChangeLog: true,
  },
  ViewgPanelApi: {
    name: 'Can View gPanel API',
    value: 'viewgPanelApi',
    type: 'view',
    group: 'administration',
    currentlyUsed: true,
    hasChangeLog: false,
  },
};

export const DirectoryRoles = {
  AddAllCurrentAndFutureUsersWithinDomain: {
    name: 'Can toggle domain-wide auto-enrollment for group membership',
    value: 'addAllCurrentAndFutureUsersWithinDomain',
    type: 'update',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ChangeProfilePicture: {
    name: 'Change Profile Picture',
    value: 'changeProfilePicture',
    type: 'update',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditEmailAddress: {
    name: 'Edit Email Addresses',
    value: 'editEmailAddress',
    type: 'update',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditPhoneNumbers: {
    name: 'Edit Phone Numbers',
    value: 'editPhoneNumbers',
    type: 'update',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditOrganizations: {
    name: 'Edit Organizations',
    value: 'editOrganizations',
    type: 'update',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewOrgUnits: {
    name: 'View Org Units',
    value: 'viewOrgUnits',
    type: 'view',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  AddOrgUnit: {
    name: 'Add Org Unit',
    value: 'addOrgUnit',
    type: 'create',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditOrgUnit: {
    name: 'Edit Org Unit',
    value: 'editOrgUnit',
    type: 'update',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RemoveOrgUnit: {
    name: 'Remove Org Unit',
    value: 'removeOrgUnit',
    type: 'delete',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditGroupHealthSettings: {
    name: 'Edit Group Health Settings',
    value: 'editGroupHealthSettings',
    type: 'update',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditRelationships: {
    name: 'Edit Relationships',
    value: 'editRelationships',
    type: 'update',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditInstantMessaging: {
    name: 'Edit Instant Messaging',
    value: 'editInstantMessaging',
    type: 'update',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditAddresses: {
    name: 'Edit Addresses',
    value: 'editAddresses',
    type: 'update',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditExternalIds: {
    name: 'Edit External Ids',
    value: 'editExternalIds',
    type: 'update',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditWebsites: {
    name: 'Edit Websites',
    value: 'editWebsites',
    type: 'update',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditNotes: {
    name: 'Edit Notes',
    value: 'editNotes',
    type: 'update',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditGender: {
    name: 'Edit Gender',
    value: 'editGender',
    type: 'update',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  AddMemberToGroup: {
    name: 'Add Member To Group',
    value: 'addMemberToGroup',
    type: 'create',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  AddExternalMemberToGroup: {
    name: 'Add External Member To Group',
    value: 'addExternalMemberToGroup',
    type: 'create',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditCustomAttributes: {
    name: 'Edit Custom Attributes',
    value: 'editCustomAttributes',
    type: 'update',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewGroups: {
    name: 'View Groups',
    value: 'viewGroups',
    type: 'view',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  CreateGroup: {
    name: 'Create Group',
    value: 'createBusinessGroup',
    type: 'create',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DeleteGroup: {
    name: 'Delete Group',
    value: 'deleteBusinessGroup',
    type: 'delete',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewGroupTemplates: {
    name: 'View Group Templates',
    value: 'viewGroupTemplates',
    type: 'view',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  CreateGroupTemplate: {
    name: 'Create Group Template',
    value: 'createGroupTemplate',
    type: 'create',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditGroupTemplates: {
    name: 'Edit Group Templates',
    value: 'editGroupTemplate',
    type: 'update',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DeleteGroupTemplates: {
    name: 'Delete Group Templates',
    value: 'deleteGroupTemplate',
    type: 'delete',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ApplyGroupTemplate: {
    name: 'Apply Group Template',
    value: 'applyGroupTemplate',
    type: 'update',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditGeneralInfoSection: {
    name: 'Edit General Info Section',
    value: 'editGeneralInfoSection',
    type: 'update',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  AddGroupAliases: {
    name: 'Add Group Aliases',
    value: 'addGroupAliases',
    type: 'create',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DeleteGroupAliases: {
    name: 'Delete Group Aliases',
    value: 'removeGroupAliases',
    type: 'delete',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RemoveMemberFromGroup: {
    name: 'Remove Member From Group',
    value: 'removeMemberFromGroup',
    type: 'delete',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditGroupMemberRole: {
    name: 'Edit Group Member Role',
    value: 'editRoleOfGroupMember',
    type: 'update',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewHistoryTab: {
    name: 'View History Tab',
    value: 'viewHistoryTab',
    type: 'view',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  ViewSharedContacts: {
    name: 'View Shared Contacts',
    value: 'viewSharedContacts',
    type: 'view',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  AddSharedContacts: {
    name: 'Add Shared Contacts',
    value: 'addSharedContacts',
    type: 'create',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DeleteSharedContacts: {
    name: 'Delete Shared Contacts',
    value: 'removeSharedContacts',
    type: 'delete',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditSharedContacts: {
    name: 'Edit Shared Contacts',
    value: 'editSharedContacts',
    type: 'update',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditDirectorySection: {
    name: 'Edit Directory Section',
    value: 'editDirectorySection',
    type: 'update',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditContentControlSection: {
    name: 'Edit Content Control Section',
    value: 'editContectControlSection',
    type: 'update',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditSettingsSection: {
    name: 'Edit Settings Section',
    value: 'editSettingsSection',
    type: 'update',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditPermissionsSection: {
    name: 'Edit Permissions Section',
    value: 'editPermissionsSection',
    type: 'update',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditAdvancedSection: {
    name: 'Edit Advanced Section',
    value: 'editAdvancedSection',
    type: 'update',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewContactSync: {
    name: 'View Contact Sync',
    value: 'viewContactSync',
    type: 'view',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  ViewContactSyncUsers: {
    name: 'View Contact Sync Users',
    value: 'viewContactSyncUsers',
    type: 'view',
    group: 'directory',
    currentlyUsed: false,
    hasChangeLog: false,
  },
  AddContactSync: {
    name: 'Add Contact Sync',
    value: 'addContactSync',
    type: 'create',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DeleteContactSync: {
    name: 'Delete Contact Sync',
    value: 'removeContactSync',
    type: 'delete',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditContactSync: {
    name: 'Edit Contact Sync',
    value: 'editContactSync',
    type: 'update',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RemoveContactSyncLabel: {
    name: 'Remove Contact Sync Label',
    value: 'removeLabelForContactSync',
    type: 'delete',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditGroupSecuritySettings: {
    name: 'Edit Group Security Settings',
    value: 'editGroupSecuritySettings',
    type: 'update',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditGroupLabels: {
    name: 'Edit Group Labels',
    value: 'editGroupLabels',
    type: 'update',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CloneGroup: {
    name: 'Clone Group',
    value: 'cloneGroup',
    type: 'create',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditGroupMemberExpiry: {
    name: 'Edit Group Member Expiry',
    value: 'editGroupMemberExpiry',
    type: 'update',
    group: 'directory',
    currentlyUsed: true,
    hasChangeLog: true,
  },
};

export const CalendarRoles = {
  ViewCalendars: {
    name: 'View Calendars',
    value: 'viewCalendars',
    type: 'view',
    group: 'calendars',
    currentlyUsed: false,
    hasChangeLog: true,
  },
  CreateCalendars: {
    name: 'Create Calendars',
    value: 'createCalendars',
    type: 'create',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DeleteCalendars: {
    name: 'Delete Calendars',
    value: 'deleteCalendars',
    type: 'delete',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RenameCalendars: {
    name: 'Rename Calendars',
    value: 'renameCalendars',
    type: 'update',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanTransferCalendars: {
    name: 'Can Transfer Calendars',
    value: 'canTransferCalendars',
    type: 'update',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditCalendarColor: {
    name: 'Edit Calendar Color',
    value: 'editCalendarColor',
    type: 'update',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditCalendarLocation: {
    name: 'Edit Calendar Location',
    value: 'editCalendarLocation',
    type: 'update',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditCalendarDescription: {
    name: 'Edit Calendar Description',
    value: 'editCalendarDescription',
    type: 'update',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditCalendarTimezone: {
    name: 'Edit Calendar Timezone',
    value: 'editCalendarTimezone',
    type: 'update',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditCalendarVisibility: {
    name: 'Edit Calendar Visibility',
    value: 'editCalendarVisibility',
    type: 'update',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  AddShareToCalendar: {
    name: 'Add Share To Calendar',
    value: 'addShareToCalendar',
    type: 'update',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditCalendarsShares: {
    name: 'Edit Calendars Shares',
    value: 'editCalendarsShares',
    type: 'update',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RemoveCalendarsShares: {
    name: 'Remove Calendars Shares',
    value: 'removeCalendarsShares',
    type: 'delete',
    group: 'calendars',
    currentlyUsed: false,
    hasChangeLog: true,
  },
  ViewTransferOwnershipLogs: {
    name: 'View Transfer Ownership Logs',
    value: 'viewTransferOwnershipLogs',
    type: 'view',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  ViewCalendarEvents: {
    name: 'View Calendar Events',
    value: 'viewCalendarEvents',
    type: 'view',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  AddEvents: {
    name: 'Add Events',
    value: 'addEvents',
    type: 'create',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RemoveEvents: {
    name: 'Remove Events',
    value: 'removeEvents',
    type: 'delete',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RemoveAllEvents: {
    name: 'Remove All Events',
    value: 'removeAllEvents',
    type: 'delete',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  UpdateEvents: {
    name: 'Update Events',
    value: 'updateEvents',
    type: 'update',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  MoveEvents: {
    name: 'Move Events',
    value: 'moveEvents',
    type: 'update',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewResourceTemplates: {
    name: 'View Resource Templates',
    value: 'viewResourceTemplates',
    type: 'view',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  CreateResourceTemplate: {
    name: 'Create Resource Template',
    value: 'createResourceTemplate',
    type: 'create',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DeleteResourceTemplate: {
    name: 'Delete Resource Template',
    value: 'deleteResourceTemplate',
    type: 'delete',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditResourceTemplate: {
    name: 'Edit Resource Template',
    value: 'editResourceTemplate',
    type: 'update',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanSelectCategoryUnknown: {
    name: 'Can Select Category Unknown',
    value: 'canSelectCategoryUnknown',
    type: 'update',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanSelectConferenceRoom: {
    name: 'Can Select Conference Room',
    value: 'canSelectConferenceRoom',
    type: 'update',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanSelectOther: {
    name: 'Can Select Other',
    value: 'canSelectOther',
    type: 'update',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewResourceCalendars: {
    name: 'View Resource Calendars',
    value: 'viewCalendarResources',
    type: 'view',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CreateResourceCalendar: {
    name: 'Create Resource Calendar',
    value: 'createResourceCalendar',
    type: 'create',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DeleteResourceCalendar: {
    name: 'Delete Resource Calendar',
    value: 'deleteResourceCalendar',
    type: 'delete',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditResourceCalendar: {
    name: 'Edit Resource Calendar',
    value: 'editResourceCalendar',
    type: 'update',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewResourcesByBuildings: {
    name: 'View Resources By Buildings',
    value: 'viewResourcesByBuildings',
    type: 'view',
    group: 'calendars',
    currentlyUsed: false,
    hasChangeLog: false,
  },
  ViewBuildings: {
    name: 'View Buildings',
    value: 'viewBuildings',
    type: 'view',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  CreateBuildings: {
    name: 'Create Buildings',
    value: 'createBuildings',
    type: 'create',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditBuildings: {
    name: 'Edit Buildings',
    value: 'editBuildings',
    type: 'update',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DeleteBuildings: {
    name: 'Delete Buildings',
    value: 'deleteBuildings',
    type: 'delete',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewFeatures: {
    name: 'View Features',
    value: 'viewFeatures',
    type: 'view',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  CreateFeatures: {
    name: 'Create Features',
    value: 'createFeatures',
    type: 'create',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditFeatures: {
    name: 'Edit Features',
    value: 'editFeatures',
    type: 'update',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DeleteFeatures: {
    name: 'Delete Features',
    value: 'deleteFeatures',
    type: 'delete',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditShareOfResourceCalendar: {
    name: 'Edit Share Of Resource Calendar',
    value: 'editShareOfResourceCalendar',
    type: 'update',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RemoveShareFromResourceCalendar: {
    name: 'Remove Share From Resource Calendar',
    value: 'removeShareFromResourceCalendar',
    type: 'update',
    group: 'calendars',
    currentlyUsed: false,
    hasChangeLog: true,
  },
  ViewResourceCalendarEvents: {
    name: 'View Resource Calendar Events',
    value: 'viewResourceCalendarEvents',
    type: 'view',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  AddResourceEvents: {
    name: 'Add Resource Events',
    value: 'addResourceEvents',
    type: 'create',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RemoveResourceEvents: {
    name: 'Remove Resource Events',
    value: 'removeResourceEvents',
    type: 'delete',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditResourceEvents: {
    name: 'Edit Resource Events',
    value: 'updateResourceEvents',
    type: 'update',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewResourceCalendarShares: {
    name: 'View Resource Calendar Shares',
    value: 'viewResourceCalendarShares',
    type: 'view',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanEditResourceCalendarName: {
    name: 'Can Edit Resource Calendar Name',
    value: 'canEditResourceCalendarName',
    type: 'update',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanEditResourceCalendarCategory: {
    name: 'Can Edit Resource Calendar Category',
    value: 'canEditResourceCalendarCategory',
    type: 'update',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanEditResourceCalendarType: {
    name: 'Can Edit Resource Calendar Type',
    value: 'canEditResourceCalendarType',
    type: 'update',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanEditResourceCalendarBuilding: {
    name: 'Can Edit Resource Calendar Building',
    value: 'canEditResourceCalendarBuilding',
    type: 'update',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanEditResourceCalendarFloor: {
    name: 'Can Edit Resource Calendar Floor',
    value: 'canEditResourceCalendarFloor',
    type: 'update',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanEditResourceCalendarFloorSection: {
    name: 'Can Edit Resource Calendar Floor Section',
    value: 'canEditResourceCalendarFloorSection',
    type: 'update',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanEditResourceCalendarCapacity: {
    name: 'Can Edit Resource Calendar Capacity',
    value: 'canEditResourceCalendarCapacity',
    type: 'update',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanEditResourceCalendarFeatures: {
    name: 'Can Edit Resource Calendar Features',
    value: 'canEditResourceCalendarFeatures',
    type: 'update',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanEditResourceCalendarUserVisibleDescription: {
    name: 'Can Edit Resource Calendar User Visible Description',
    value: 'canEditResourceCalendarUserVisibleDescription',
    type: 'update',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanEditResourceCalendarInternalDescription: {
    name: 'Can Edit Resource Calendar Internal Description',
    value: 'canEditResourceCalendarInternalDescription',
    type: 'update',
    group: 'calendars',
    currentlyUsed: true,
    hasChangeLog: true,
  },
};

export const RulesEngineRoles = {
  ViewRulesGrid: {
    name: 'View Rules Engine',
    value: 'viewRulesGrid',
    type: 'view',
    group: 'rulesEngine',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  ViewRulesDetails: {
    name: 'View Rules Details',
    value: 'viewRulesDetails',
    type: 'view',
    group: 'rulesEngine',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  AddRules: {
    name: 'Add Rules',
    value: 'createRule',
    type: 'create',
    group: 'rulesEngine',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditRules: {
    name: 'Edit Rules',
    value: 'editRule',
    type: 'update',
    group: 'rulesEngine',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ChangeRuleStatus: {
    name: 'Change Rule Status',
    value: 'changeRuleStatus',
    type: 'update',
    group: 'rulesEngine',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DeleteRules: {
    name: 'Delete Rules',
    value: 'deleteRules',
    type: 'delete',
    group: 'rulesEngine',
    currentlyUsed: true,
    hasChangeLog: true,
  },
};

export const ToolsRoles: RoleConfig = {
  ViewReports: {
    name: 'Can View Reports',
    value: 'viewReports',
    type: 'view',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  ViewPolicies: {
    name: 'Can View Policies',
    value: 'viewPolicies',
    type: 'view',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  ViewSignatureTemplates: {
    name: 'Can View Signature Templates',
    value: 'viewSignatureTemplates',
    type: 'view',
    group: 'tools',
    currentlyUsed: false,
    hasChangeLog: false,
  },
  ViewBulkImports: {
    name: 'Can View Bulk Operations',
    value: 'viewBulkImports',
    type: 'view',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  ViewMobileManagement: {
    name: 'Can View Mobile Management',
    value: 'viewMobileManagement',
    type: 'view',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  ViewDeviceManagement: {
    name: 'Can View Chrome Devices',
    value: 'viewDeviceManagement',
    type: 'view',
    group: 'tools',
    currentlyUsed: false,
    hasChangeLog: false,
  },
  ViewGmailExport: {
    name: 'Can View Gmail Export',
    value: 'viewGmailExport',
    type: 'view',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  ViewAccountAudit: {
    name: 'Can View Account Audit',
    value: 'viewAccountAudit',
    type: 'view',
    group: 'tools',
    currentlyUsed: false,
    hasChangeLog: false,
  },
  ViewCPanelLogs: {
    name: 'Can View cPanel Logs',
    value: 'viewCPanelLogs',
    type: 'view',
    group: 'tools',
    currentlyUsed: false,
    hasChangeLog: false,
  },
  CanApproveMobile: {
    name: 'Approve Mobile Devices',
    value: 'canApproveMobile',
    type: 'update',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanDeleteMobile: {
    name: 'Delete Mobile Devices',
    value: 'canDeleteMobile',
    type: 'delete',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanBlockMobile: {
    name: 'Block Mobile Devices',
    value: 'canBlockMobile',
    type: 'update',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanRemoteWipeMobile: {
    name: 'Remote Wipe Mobile Devices',
    value: 'canRemoteWipeMobile',
    type: 'update',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanRemoteWipeAccountMobile: {
    name: 'Remote Wipe Mobile Device Accounts',
    value: 'canRemoteWipeAccountMobile',
    type: 'update',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanExportMobileDevices: {
    name: 'Export Mobile Devices',
    value: 'canExportMobileDevices',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanDeprovisionDevices: {
    name: 'Deprovision Devices',
    value: 'canDeprovisionDevices',
    type: 'update',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanDisableDevices: {
    name: 'Disable Devices',
    value: 'canDisableDevices',
    type: 'update',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanReenableDevices: {
    name: 'Enable Devices',
    value: 'canReenableDevices',
    type: 'update',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CanMoveDevices: {
    name: 'Move Devices',
    value: 'canMoveDevices',
    type: 'update',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewDecommissioning: {
    name: 'Can View Decommissioning Processes',
    value: 'viewDecommissioning',
    type: 'view',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  CreateDecommissioningProcesses: {
    name: 'Create Decommissioning Processes',
    value: 'createDecommissioningProcesses',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditDecommissioningProcesses: {
    name: 'Edit Decommissioning Processes',
    value: 'editDecommissioningProcesses',
    type: 'update',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DeleteDecommissioningProcesses: {
    name: 'Delete Decommissioning Processes',
    value: 'deleteDecommissioningProcesses',
    type: 'delete',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunDecommissioningProcess: {
    name: 'Run Decommissioning Process',
    value: 'runDecommissioningProcess',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DisableDecommissioningProcesses: {
    name: 'Disable Decommissioning Process',
    value: 'disableDecommissioningProcesses',
    type: 'update',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EnableDecommissioningProcesses: {
    name: 'Enable Decommissioning Process',
    value: 'enableDecommissioningProcesses',
    type: 'update',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CreateReport: {
    name: 'Create Report',
    value: 'createReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: false,
    hasChangeLog: true,
  },
  DeleteReport: {
    name: 'Delete Report',
    value: 'deleteReport',
    type: 'delete',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditReport: {
    name: 'Edit Report',
    value: 'editReport',
    type: 'update',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  MaunalRunReport: {
    name: 'Run All Reports',
    value: 'maunalRunReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunApprovedEmailForwardingReport: {
    name: 'Run Approved Email Forwarding Report',
    value: 'runApprovedEmailForwardingReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunArchivedUsersReport: {
    name: 'Run Archive Users Report',
    value: 'runArchivedUsersReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunCalendarResourceReport: {
    name: 'Run Calendar Resource Report',
    value: 'runCalendarResourceReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunCalendarAccessReport: {
    name: 'Run Calendar Access Report',
    value: 'runCalendarAccessReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunCalendarReport: {
    name: 'Run Calendar Events Report',
    value: 'runCalendarReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunCalendarAbandonedEventsReport: {
    name: 'Run Calendar Abandoned Events Report',
    value: 'runCalendarAbandonedEventsReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunCustomerUsageReport: {
    name: 'Run Customer Usage Report',
    value: 'runCustomerUsageReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunDocsCreatedReport: {
    name: 'Run Documents Created Report',
    value: 'runDocsCreatedReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunDocsActivityReport: {
    name: 'Run Docs Activity Report',
    value: 'runDocsActivityReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunDocsModOver14: {
    name: 'Run Docs Modified in Last 14 Days Report',
    value: 'runDocsModOver14',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunDocsModOverX: {
    name: 'Run Docs Modified in Last X Days Report',
    value: 'runDocsModOverX',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunDocsOver100Mb: {
    name: 'Run Docs Over 100MB Report',
    value: 'runDocsOver100Mb',
    type: 'create',
    group: 'tools',
    currentlyUsed: false,
    hasChangeLog: true,
  },
  RunDocsOver10Mb: {
    name: 'Run Docs Over 10MB Report',
    value: 'runDocsOver10Mb',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunDocsSharedExternally: {
    name: 'Run Docs Shared Externally Report',
    value: 'runDocsSharedExternally',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunDocsSharedPublic: {
    name: 'Run Docs Shared Publicly Report',
    value: 'runDocsSharedPublic',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunDocsSharedWithGroups: {
    name: 'Run Docs Shared With Groups Report',
    value: 'runDocsSharedWithGroups',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunDocsSharedWithDomain: {
    name: 'Run Docs Shared With Domain Report',
    value: 'runDocsSharedWithDomain',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunDocsSharedWithLink: {
    name: 'Run Docs Shared With Link Report',
    value: 'runDocsSharedWithLink',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunCreditCardAndSSNReport: {
    name: 'Run docs that contain a CC number or SSN Report',
    value: 'runCreditCardAndSSNReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunDocsMP3Ext: {
    name: 'Run Docs With MP3 Extension Report',
    value: 'runDocsMP3Ext',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunEmailDelegateReport: {
    name: 'Run Email Delegate Report',
    value: 'runEmailDelegateReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunEmailForwardingReport: {
    name: 'Run Email Forwarding Report',
    value: 'runEmailForwardingReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunEmailMonitoringReport: {
    name: 'Run Email Monitoring Report',
    value: 'runEmailMonitoringReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunEmptyGroupReport: {
    name: 'Run Empty Group Report',
    value: 'runEmptyGroupReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunExportPersonalContactsReport: {
    name: 'Run Export Personal Contacts Report',
    value: 'runExportPersonalContactsReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunGroupExport: {
    name: 'Run Group Report',
    value: 'runGroupExport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunGroupMembership: {
    name: 'Run Group Membership Report',
    value: 'runGroupMembership',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunGroupMemberCountReport: {
    name: 'Run Group Member Count Report',
    value: 'runGroupMemberCountReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunGroupWithNestedGroupsReport: {
    name: 'Run Groups With Nested Groups Report',
    value: 'runGroupWithNestedGroupsReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunGroupsWithNoOwners: {
    name: 'Run Groups With No Owners Report',
    value: 'runGroupsWithNoOwners',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunSignatures: {
    name: 'Run Signatures Report',
    value: 'runSignatures',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunUsersWhoAreNotMemberOfAnyGroup: {
    name: 'Run Users who are not member of any Group',
    value: 'runUsersWhoAreNotMemberOfAnyGroup',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunHiddenUserReport: {
    name: 'Run Hidden User Report',
    value: 'runHiddenUserReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunInactiveUserReport: {
    name: 'Run Inactive User Report',
    value: 'runInactiveUserReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunLicenseTypes: {
    name: 'Run License Types Report',
    value: 'runLicenseTypes',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunListUserGmailFiltersReport: {
    name: 'Run List User Gmail Filters Report',
    value: 'runListUserGmailFiltersReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunLoginReport: {
    name: 'Run Last Login Time Report',
    value: 'runLoginReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunLoginActivityReport: {
    name: 'Run Login Activity Report',
    value: 'runLoginActivityReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunMobileDeviceDump: {
    name: 'Run Mobile Device Report',
    value: 'runMobileDeviceDump',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunMobileAppsReport: {
    name: 'Run Mobile Apps Report',
    value: 'runMobileAppsReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunOrgMemberCount: {
    name: 'Run Orgs Member Count Report',
    value: 'runOrgMemberCount',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunEmptyOrg: {
    name: 'Run Orgs With No Members Report',
    value: 'runEmptyOrg',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunSendAsAddresses: {
    name: 'Run Send As Addresses',
    value: 'runSendAsAddresses',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunSharedContactExport: {
    name: 'Run Shared Contact Report',
    value: 'runSharedContactExport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunSharedDrivesReport: {
    name: 'Run Shared Drives Report',
    value: 'runSharedDrivesReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunSharedDriveDocsSharedExternallyReport: {
    name: 'Run Shared Drives Docs Shared Externally Report',
    value: 'runSharedDriveDocsSharedExternallyReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunSiteOwnership: {
    name: 'Run Site Ownership',
    value: 'runSiteOwnership',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunSuperAdminReport: {
    name: 'Run Super Admin Report',
    value: 'runSuperAdminReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunStorageReport: {
    name: 'Run Storage Report',
    value: 'runStorageReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunSuspendedReport: {
    name: 'Run Suspended User Report',
    value: 'runSuspendedReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunTwoFactorEnrolled: {
    name: 'Run Two Factor Enrolled Report',
    value: 'runTwoFactorEnrolled',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunUserProfileReport: {
    name: 'Run User Profile Report',
    value: 'runUserProfileReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunQuotaReport: {
    name: 'Run User Quota Report',
    value: 'runQuotaReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunGmailBreakdownReport: {
    name: 'Run Gmail Breakdown Report',
    value: 'runGmailBreakdownReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunUserUsageReport: {
    name: 'Run User Usage Report',
    value: 'runUserUsageReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DomainPinReports: {
    name: 'Domain Pin Reports',
    value: 'domainPinReports',
    type: 'update',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  RunEmailActivityReport: {
    name: 'Run Email Activity Report',
    value: 'runEmailActivityReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunNestedGroupReport: {
    name: 'Run Nested Group Reports',
    value: 'runNestedGroupReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunThirdPartyApplicationReport: {
    name: 'Run Third Party Application Reports',
    value: 'runthirdPartyApplicationReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunExportAdminLogsReport: {
    name: 'Run Export Admin Logs Reports',
    value: 'runExportAdminLogsReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunUnmodifiedDocumentsReport: {
    name: 'Run Unmodified Documents Report',
    value: 'runUnmodifiedDocumentsReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunExternallyOwnedDocsReport: {
    name: 'Run Externally Owned Docs Report',
    value: 'runExternallyOwnedDocsReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CreateTemplates: {
    name: 'Create Signature Template',
    value: 'createTemplates',
    type: 'create',
    group: 'tools',
    currentlyUsed: false,
    hasChangeLog: true,
  },
  DeleteTemplates: {
    name: 'Delete Signature Template',
    value: 'deleteTemplates',
    type: 'delete',
    group: 'tools',
    currentlyUsed: false,
    hasChangeLog: true,
  },
  EditTemplate: {
    name: 'Edit Signature Template',
    value: 'editTemplate',
    type: 'update',
    group: 'tools',
    currentlyUsed: false,
    hasChangeLog: true,
  },
  MaunalRunTemplate: {
    name: 'Run Signature Template',
    value: 'maunalRunTemplate',
    type: 'create',
    group: 'tools',
    currentlyUsed: false,
    hasChangeLog: true,
  },
  CreatePolicy: {
    name: 'Create Policy',
    value: 'createPolicy',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DeletePolicy: {
    name: 'Delete Policy',
    value: 'deletePolicy',
    type: 'delete',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditPolicy: {
    name: 'Edit Policy',
    value: 'editPolicy',
    type: 'update',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CopyPolicy: {
    name: 'Copy Policy',
    value: 'copyPolicy',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  MaunalRunPolicy: {
    name: 'Run Policy',
    value: 'maunalRunPolicy',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ImportGroupChange: {
    name: 'Run Group Bulk Operations',
    value: 'importGroupChange',
    type: 'create',
    group: 'tools',
    currentlyUsed: false,
    hasChangeLog: true,
    isBulkOp: true,
  },
  ImportUserChange: {
    name: 'Run Users Bulk Operations',
    value: 'importUserChange',
    type: 'create',
    group: 'tools',
    currentlyUsed: false,
    hasChangeLog: true,
    isBulkOp: true,
  },
  ImportSharedContacts: {
    name: 'Run Shared Contacts Bulk Operations',
    value: 'importSharedContacts',
    type: 'create',
    group: 'tools',
    currentlyUsed: false,
    hasChangeLog: true,
    isBulkOp: true,
  },
  BulkLabelDriveDocs: {
    name: 'Run Bulk Apply Labels Operations',
    value: 'bulkLabelDriveDocs',
    type: 'update',
    group: 'tools',
    currentlyUsed: false,
    hasChangeLog: true,
    isBulkOp: true,
  },
  BulkGroupDeletion: {
    name: 'Run Bulk Group Deletion Operations',
    value: 'bulkGroupDeletion',
    type: 'delete',
    group: 'tools',
    currentlyUsed: false,
    hasChangeLog: true,
    isBulkOp: true,
  },
  BulkGroupRemoval: {
    name: 'Run Bulk Group Removal Operations',
    value: 'bulkGroupRemoval',
    type: 'delete',
    group: 'tools',
    currentlyUsed: false,
    hasChangeLog: true,
    isBulkOp: true,
  },
  BulkGroupMemberSettingsUpdate: {
    name: 'Run Bulk Group Member Settings Update Operations',
    value: 'bulkGroupMemberSettingsUpdate',
    type: 'update',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
    isBulkOp: true,
  },
  BulkAssignAuLicenses: {
    name: 'Run Bulk Assign Archive User Licenses',
    value: 'bulkAssignAuLicenses',
    type: 'update',
    group: 'tools',
    currentlyUsed: false,
    hasChangeLog: true,
    isBulkOp: true,
  },
  ClearUsersFromGroup: {
    name: 'Run Clear Users From Group Operations',
    value: 'clearUsersFromGroup',
    type: 'update',
    group: 'tools',
    currentlyUsed: false,
    hasChangeLog: true,
    isBulkOp: true,
  },
  UsersVacationResponder: {
    name: 'Run Multiple User Vacation Responder Operation',
    value: 'usersVacationResponder',
    type: 'update',
    group: 'tools',
    currentlyUsed: false,
    hasChangeLog: true,
    isBulkOp: true,
  },
  ForcePasswordReset: {
    name: 'Run Bulk Force Password Reset Operations',
    value: 'forcePasswordReset',
    type: 'update',
    group: 'tools',
    currentlyUsed: false,
    hasChangeLog: true,
    isBulkOp: true,
  },
  ForceSignOut: {
    name: 'Run Bulk Force Sign Out Operations',
    value: 'forceSignOut',
    type: 'update',
    group: 'tools',
    currentlyUsed: false,
    hasChangeLog: true,
    isBulkOp: true,
  },
  RemoveShares: {
    name: 'Run Bulk Remove Shares Operations',
    value: 'removeShares',
    type: 'delete',
    group: 'tools',
    currentlyUsed: false,
    hasChangeLog: true,
    isBulkOp: true,
  },
  SharedContactRemoval: {
    name: 'Run Bulk Delete Shared Contacts Operations',
    value: 'sharedContactRemoval',
    type: 'delete',
    group: 'tools',
    currentlyUsed: false,
    hasChangeLog: true,
    isBulkOp: true,
  },
  PersonalContactRemoval: {
    name: 'Run Bulk Delete Personal Contacts Operations',
    value: 'personalContactRemoval',
    type: 'delete',
    group: 'tools',
    currentlyUsed: false,
    hasChangeLog: true,
    isBulkOp: true,
  },
  BulkUploadProfilePics: {
    name: 'Run Bulk Profile Picture Upload',
    value: 'bulkUploadProfilePics',
    type: 'update',
    group: 'tools',
    currentlyUsed: false,
    hasChangeLog: true,
    isBulkOp: true,
  },
  RunBulkUploadUsers: {
    name: 'Run Bulk Upload Users',
    value: 'runBulkUploadUsers',
    type: 'create',
    group: 'tools',
    currentlyUsed: false,
    hasChangeLog: true,
    isBulkOp: true,
  },
  RunDriveTransfer: {
    name: 'Run Bulk Drive Transfer',
    value: 'runDriveTransfer',
    type: 'update',
    group: 'tools',
    currentlyUsed: false,
    hasChangeLog: true,
    isBulkOp: true,
  },
  CalendarEventsImport: {
    name: 'Run Bulk Calendar Events Import',
    value: 'calendarEventsImport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
    isBulkOp: true,
  },
  CalendarPermissionSettings: {
    name: 'Run Bulk Calendar Permission Settings',
    value: 'calendarPermissionSettings',
    type: 'update',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
    isBulkOp: true,
  },
  SignatureTemplateBlackListStatus: {
    name: 'Run Bulk Signature Template Blocklist Status',
    value: 'signatureTemplateBlackListStatus',
    type: 'update',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
    isBulkOp: true,
  },
  SignatureTemplateReport: {
    name: 'Run Signature Template Report',
    value: 'signatureTemplateReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  TimeAndIPAddressOfLoggedInUser: {
    name: 'Run Time and IP Address Report of Logged In Users',
    value: 'timeAndIPAddressOfLoggedInUser',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CreateGmailExports: {
    name: 'Create Gmail Export',
    value: 'createGmailExports',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DeleteGmailExports: {
    name: 'Delete Gmail Export',
    value: 'deleteGmailExports',
    type: 'delete',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DownloadGmailExport: {
    name: 'Download Gmail Exports',
    value: 'downloadGmailExport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  SetGmailExportKey: {
    name: 'Set the Encryption Key',
    value: 'setGmailExportKey',
    type: 'update',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CreateGmailSearch: {
    name: 'Create Gmail Search',
    value: 'createGmailSearch',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DeleteGmailSearch: {
    name: 'Delete Gmail Search',
    value: 'deleteGmailSearch',
    type: 'delete',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewGmailSearch: {
    name: 'View Gmail Deletion',
    value: 'viewGmailSearch',
    type: 'view',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  RunGmailSearch: {
    name: 'Run Gmail Search',
    value: 'runGmailSearch',
    type: 'create',
    group: 'tools',
    currentlyUsed: false,
    hasChangeLog: true,
  },
  ReportGmailSearch: {
    name: 'Report Gmail Search',
    value: 'reportGmailSearch',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RunHangoutsReport: {
    name: 'Hangouts Report',
    value: 'runHangoutsReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DeleteSuspendedUsers: {
    name: 'Delete User from Decom',
    value: 'deleteSuspendedUsers',
    type: 'delete',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  PauseDecomForUser: {
    name: 'Pause User Decom Processing',
    value: 'pauseDecomForUser',
    type: 'update',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  UnpauseDecomForUser: {
    name: 'Unpause User Decom Processing',
    value: 'unpauseDecomForUser',
    type: 'update',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  PurgeDecomForUser: {
    name: 'Purge Decom User',
    value: 'purgeDecomUser',
    type: 'update',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  TerminateDecomForUser: {
    name: 'Terminate Decom User',
    value: 'terminateDecomUser',
    type: 'update',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  AbandonedCalendarEvents: {
    name: 'Run Abandoned Calendar Events',
    value: 'abandonedCalendarEvents',
    type: 'create',
    group: 'tools',
    currentlyUsed: false,
    hasChangeLog: true,
    isBulkOp: true,
  },
  ViewSignatureBlocklist: {
    name: 'View Signature Blocklist',
    value: 'viewSignatureBlocklist',
    type: 'view',
    group: 'tools',
    currentlyUsed: false,
    hasChangeLog: false,
  },
  RunAdminRoleReport: {
    name: 'Run gPanel Role Report',
    value: 'runAdminRoleReport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  GPanelRoleImport: {
    name: 'Run gPanel Role Import',
    value: 'gPanelRoleImport',
    type: 'create',
    group: 'tools',
    currentlyUsed: true,
    hasChangeLog: true,
    isBulkOp: true,
  },
};

export const VaultRoles: RoleConfig = {
  ViewAllVault: {
    name: 'View All Vault',
    value: 'viewAllVault',
    type: 'view',
    group: 'vault',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  ViewVaultMatters: {
    name: 'View Matters',
    value: 'viewVaultMatters',
    type: 'view',
    group: 'vault',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  ViewVaultExports: {
    name: 'View all Exports',
    value: 'viewVaultExports',
    type: 'view',
    group: 'vault',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  ViewGmailVaultExport: {
    name: 'View Gmail Vault Export',
    value: 'viewGmailVaultExport',
    type: 'view',
    group: 'vault',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  ViewChatVaultExport: {
    name: 'View Chat Vault Export',
    value: 'viewChatVaultExport',
    type: 'view',
    group: 'vault',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  ViewGeminiVaultExport: {
    name: 'View Gemini Vault Export',
    value: 'viewGeminiVaultExport',
    type: 'view',
    group: 'vault',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  ViewCalendarVaultExport: {
    name: 'View Calendar Vault Export',
    value: 'viewCalendarVaultExport',
    type: 'view',
    group: 'vault',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  ViewDriveVaultExport: {
    name: 'View Drive Vault Export',
    value: 'viewDriveVaultExport',
    type: 'view',
    group: 'vault',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  ViewGroupsVaultExport: {
    name: 'View Groups Vault Export',
    value: 'viewGroupsVaultExport',
    type: 'view',
    group: 'vault',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  CreateVaultExports: {
    name: 'Create Any Service Vault Export',
    value: 'createVaultExports',
    type: 'create',
    group: 'vault',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CreateGmailVaultExport: {
    name: 'Create Gmail Vault Export',
    value: 'createGmailVaultExport',
    type: 'create',
    group: 'vault',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CreateChatVaultExport: {
    name: 'Create Chat Vault Export',
    value: 'createChatVaultExport',
    type: 'create',
    group: 'vault',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CreateGeminiVaultExport: {
    name: 'Create Gemini Vault Export',
    value: 'createGeminiVaultExport',
    type: 'create',
    group: 'vault',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CreateCalendarVaultExport: {
    name: 'Create Calendar Vault Export',
    value: 'createCalendarVaultExport',
    type: 'create',
    group: 'vault',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CreateDriveVaultExport: {
    name: 'Create Drive Vault Export',
    value: 'createDriveVaultExport',
    type: 'create',
    group: 'vault',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CreateGroupsVaultExport: {
    name: 'Create Groups Vault Export',
    value: 'createGroupsVaultExport',
    type: 'create',
    group: 'vault',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CreateVaultMatters: {
    name: 'Create Vault Matter',
    value: 'createVaultMatters',
    type: 'create',
    group: 'vault',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditVaultMatters: {
    name: 'Edit Vault Matter',
    value: 'editVaultMatters',
    type: 'update',
    group: 'vault',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DeleteVaultExports: {
    name: 'Delete All Vault Exports',
    value: 'deleteVaultExports',
    type: 'delete',
    group: 'vault',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DeleteGmailVaultExport: {
    name: 'Delete Gmail Vault Export',
    value: 'deleteGmailVaultExport',
    type: 'delete',
    group: 'vault',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DeleteChatVaultExport: {
    name: 'Delete Chat Vault Export',
    value: 'deleteChatVaultExport',
    type: 'delete',
    group: 'vault',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DeleteGeminiVaultExport: {
    name: 'Delete Gemini Vault Export',
    value: 'deleteGeminiVaultExport',
    type: 'delete',
    group: 'vault',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DeleteCalendarVaultExport: {
    name: 'Delete Calendar Vault Export',
    value: 'deleteCalendarVaultExport',
    type: 'delete',
    group: 'vault',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DeleteDriveVaultExport: {
    name: 'Delete Drive Vault Export',
    value: 'deleteDriveVaultExport',
    type: 'delete',
    group: 'vault',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DeleteGroupsVaultExport: {
    name: 'Delete Groups Vault Export',
    value: 'deleteGroupsVaultExport',
    type: 'delete',
    group: 'vault',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DownloadVaultExport: {
    name: 'Download All Exports',
    value: 'downloadVaultExport',
    type: 'create',
    group: 'vault',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DownloadGmailVaultExport: {
    name: 'Download Gmail Vault Export',
    value: 'downloadGmailVaultExport',
    type: 'create',
    group: 'vault',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DownloadChatVaultExport: {
    name: 'Download Chat Vault Export',
    value: 'downloadChatVaultExport',
    type: 'create',
    group: 'vault',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DownloadGeminiVaultExport: {
    name: 'Download Gemini Vault Export',
    value: 'downloadGeminiVaultExport',
    type: 'create',
    group: 'vault',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DownloadCalendarVaultExport: {
    name: 'Download Calendar Vault Export',
    value: 'downloadCalendarVaultExport',
    type: 'create',
    group: 'vault',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DownloadDriveVaultExport: {
    name: 'Download Drive Vault Export',
    value: 'downloadDriveVaultExport',
    type: 'create',
    group: 'vault',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DownloadGroupsVaultExport: {
    name: 'Download Groups Vault Export',
    value: 'downloadGroupsVaultExport',
    type: 'create',
    group: 'vault',
    currentlyUsed: true,
    hasChangeLog: true,
  },
};

export const UserRoles = {
  ViewUserManagement: {
    name: 'Can View User Management',
    value: 'viewUserManagement',
    type: 'view',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  CreateUser: {
    name: 'Create Users',
    value: 'createUsers',
    type: 'create',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditProfileOnCreation: {
    name: 'Edit User Profiles During User Creation',
    value: 'editProfileOnCreation',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DeleteUsers: {
    name: 'Remove Users',
    value: 'deleteUsers',
    type: 'delete',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditAdmins: {
    name: 'Edit cPanel Admins',
    value: 'editAdmins',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: false,
    hasChangeLog: true,
  },
  BulkAddUsersToGroup: {
    name: 'Bulk Add Users To Group',
    value: 'bulkAddMemberToGroup',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  BulkRemoveUsersFromGroup: {
    name: 'Bulk Remove Users From Group',
    value: 'bulkRemovedMemberFromGroup',
    type: 'delete',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  BulkSuspendUsers: {
    name: 'Bulk Suspend Users',
    value: 'bulkSuspendUser',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  BulkRestoreUsers: {
    name: 'Bulk Restore Users',
    value: 'bulkRestoreUser',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  BulkDeleteUsers: {
    name: 'Bulk Delete Users',
    value: 'bulkDeleteUser',
    type: 'delete',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  BulkSignOutUsers: {
    name: 'Bulk Sign Out Users',
    value: 'bulkSignOutUser',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  BulkSetOrganization: {
    name: `Bulk Change Users' OrgUnit`,
    value: 'bulkSetOrganization',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  BulkChangeGpanelRole: {
    name: 'Bulk Change gPanel Role',
    value: 'bulkChangeGpanelRole',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  BulkForcePasswordReset: {
    name: 'Bulk Force Password Reset',
    value: 'bulkForcePasswordReset',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  BulkAddGmailLabel: {
    name: 'Bulk Add Gmail Label',
    value: 'bulkAddGmailLabel',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  BulkSetImap: {
    name: 'Bulk Gmail IMAP',
    value: 'bulkSetImap',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  BulkSetPop: {
    name: 'Bulk Gmail POP',
    value: 'bulkSetPop',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  BulkSetContactSharing: {
    name: 'Bulk Contact Sharing',
    value: 'bulkSetContactSharing',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ChangeEmailAddress: {
    name: 'Edit Email Address',
    value: 'changeEmailAddress',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditUserName: {
    name: `Edit User's Name`,
    value: 'editUserName',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditUserOrgUnit: {
    name: `Edit User's OrgUnit`,
    value: 'editUserOrgUnit',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditNotes: {
    name: 'Edit Notes',
    value: 'editNotes',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: false,
    hasChangeLog: true,
  },
  SetPasswords: {
    name: 'Create Random Password',
    value: 'setPasswords',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: false,
    hasChangeLog: true,
  },
  SetCustomPasswords: {
    name: 'Create Custom Password',
    value: 'setCustomPasswords',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ForcePasswordReset: {
    name: 'Force Password Reset',
    value: 'forcePasswordReset',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  GenerateBackupCodes: {
    name: 'Generate Backup Codes',
    value: 'generateBackupCodes',
    type: 'create',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DisableTwoFactorAuthentication: {
    name: 'Disable 2-Factor Authentication',
    value: 'disableTwoFactorAuthentication',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ChangeCPanelRole: {
    name: 'Edit cPanel Role',
    value: 'changeCPanelRole',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ChangeGPanelRole: {
    name: 'Edit gPanel Role',
    value: 'changeGPanelRole',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ShareContactWithDirectory: {
    name: 'Share Contact With Directory',
    value: 'shareContactWithDirectory',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  SuspendUsers: {
    name: 'Suspened/Restore Users',
    value: 'suspendUsers',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditRecoveryEmail: {
    name: 'Edit Recovery Email',
    value: 'editRecoveryEmail',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: false,
    hasChangeLog: true,
  },
  EditRecoveryPhone: {
    name: 'Edit Recovery Phone',
    value: 'editRecoveryPhone',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewAliasesTab: {
    name: 'View Aliases Tab',
    value: 'viewAliasesTab',
    type: 'view',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  AddAliases: {
    name: 'Add Aliases',
    value: 'addAliases',
    type: 'create',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RemoveAliases: {
    name: 'Remove Aliases',
    value: 'removeAliases',
    type: 'delete',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  TransferAliases: {
    name: 'Transfer Aliases',
    value: 'transferAliases',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewProfileTab: {
    name: 'View Profile Tab',
    value: 'viewProfileTab',
    type: 'view',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  ViewUserCustomAttributes: {
    name: 'View Custom Attributes',
    value: 'viewUserCustomAttributes',
    type: 'view',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  ViewGroupsTab: {
    name: 'View Group Membership Tab',
    value: 'viewGroupsTab',
    type: 'view',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  ViewUserRolesTab: {
    name: 'View User Roles Tab',
    value: 'viewUserRolesTab',
    type: 'view',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  AddGroupMembers: {
    name: 'Add Group Members',
    value: 'addGroupMembers',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RemoveGroupMembers: {
    name: 'Remove Group Members',
    value: 'removeGroupMembers',
    type: 'delete',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewContactsTab: {
    name: 'View Personal Contacts Tab',
    value: 'viewContactsTab',
    type: 'view',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  AddContacts: {
    name: 'Add Personal Contacts',
    value: 'addContacts',
    type: 'create',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  UpdateContacts: {
    name: 'Update Personal Contacts',
    value: 'updateContacts',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ExportContacts: {
    name: 'Export Personal Contacts',
    value: 'exportContacts',
    type: 'create',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  MoveContacts: {
    name: 'Move Personal Contacts',
    value: 'moveContacts',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RemoveContacts: {
    name: 'Remove Personal Contacts',
    value: 'removeContacts',
    type: 'delete',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  AddContactGroups: {
    name: 'Add Personal Contact Groups',
    value: 'addContactGroups',
    type: 'create',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditContactGroups: {
    name: 'Edit Personal Contact Groups',
    value: 'editContactGroups',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DeleteContactGroups: {
    name: 'Remove Personal Contact Groups',
    value: 'removeContactGroups',
    type: 'delete',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewGmailTab: {
    name: 'View Gmail Settings Tab',
    value: 'viewGmailTab',
    type: 'view',
    group: 'userManagement',
    currentlyUsed: false,
    hasChangeLog: false,
  },
  AddGmailAccountDelegation: {
    name: 'Add Gmail Account Delegation',
    value: 'addGmailAccountDelegation',
    type: 'create',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RemoveGmailAccountDelegation: {
    name: 'Remove Gmail Account Delegation',
    value: 'removeGmailAccountDelegation',
    type: 'delete',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewGmailFilters: {
    name: 'View Gmail Filters',
    value: 'viewGmailFilters',
    type: 'view',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  AddGmailFilters: {
    name: 'Add Gmail Filters',
    value: 'addGmailFilters',
    type: 'create',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DeleteGmailFilters: {
    name: 'Delete Gmail Filters',
    value: 'deleteGmailFilters',
    type: 'delete',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  AddGmailSendAs: {
    name: 'Add Gmail Send As',
    value: 'addGmailSendAs',
    type: 'create',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RemoveGmailSendAs: {
    name: 'Remove Gmail Send As',
    value: 'removeGmailSendAs',
    type: 'delete',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  AddGmailLabel: {
    name: 'Add Gmail Label',
    value: 'addGmailLabel',
    type: 'create',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DeleteGmailLabel: {
    name: 'Delete Gmail Label',
    value: 'deleteGmailLabel',
    type: 'delete',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditGmailPopSettings: {
    name: 'Add Gmail Pop Settings',
    value: 'editGmailPopSettings',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditGmailImapSettings: {
    name: 'Add Gmail Imap Settings',
    value: 'editGmailImapSettings',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  SetGmailVacationMessage: {
    name: 'Set Gmail Vacation Message',
    value: 'setGmailVacationMessage',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DisableGmailVacationMessage: {
    name: 'Enable/Disable Gmail Vacation Message',
    value: 'disableGmailVacationMessage',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditGmailForwarding: {
    name: 'Edit Gmail Forwarding',
    value: 'editGmailForwarding',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  SetGmailSignature: {
    name: 'Edit Gmail Signature',
    value: 'editGmailSignature',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewCalendarsTab: {
    name: 'View Calendars Tab',
    value: 'viewCalendarsTab',
    type: 'view',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewDriveTab: {
    name: 'View Drive Tab',
    value: 'viewDriveTab',
    type: 'view',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewDriveSearchTab: {
    name: 'View User Drive Search Tab',
    value: 'viewDriveSearchTab',
    type: 'view',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewAuditingTab: {
    name: 'View Auditing Tab',
    value: 'viewAuditingTab',
    type: 'view',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  AddEmailMonitors: {
    name: 'Add Email Monitors',
    value: 'addEmailMonitors',
    type: 'create',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditEmailMonitors: {
    name: 'Edit Email Monitors',
    value: 'editEmailMonitors',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RemoveEmailMonitors: {
    name: 'Remove Email Monitors',
    value: 'removeEmailMonitors',
    type: 'delete',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewDevicesTab: {
    name: 'View Devices Tab',
    value: 'viewDevicesTab',
    type: 'view',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  ViewAppPasswordsTab: {
    name: 'View App Password Tab',
    value: 'viewAppPasswordTab',
    type: 'view',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  DeleteAppPasswords: {
    name: 'Revoke App Specific Passwords',
    value: 'revokeAppPasswords',
    type: 'delete',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewThirdPartyAppsTab: {
    name: 'View Third Party Applications Tab',
    value: 'viewThirdPartyApplicationsTab',
    type: 'view',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  RevokeAuthTokens: {
    name: `Revoke Third Party Applications' Auth Tokens`,
    value: 'revokeAuthTokens',
    type: 'delete',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewHistoryTab: {
    name: 'View History Tab',
    value: 'viewHistoryTab',
    type: 'view',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  EditGmailLabel: {
    name: 'Edit Gmail Label',
    value: 'editGmailLabel',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  AddGmailForwardAddress: {
    name: 'Add Gmail Forward Address',
    value: 'addGmailForwardAddress',
    type: 'create',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DeleteGmailForwardAddress: {
    name: 'Delete Gmail Forward Address',
    value: 'deleteGmailForwardAddress',
    type: 'delete',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ArchiveUsers: {
    name: 'Archive User',
    value: 'archiveUsers',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ActivateUsers: {
    name: 'Activate User',
    value: 'activateUsers',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  SignOutUsers: {
    name: 'Sign-out User',
    value: 'signOutUsers',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ScheduleUserStatusUpdate: {
    name: 'Schedule User Status Update',
    value: 'scheduleUserStatusUpdate',
    type: 'update',
    group: 'userManagement',
    currentlyUsed: true,
    hasChangeLog: true,
  },
} as const;

export const BillingRoles = {
  viewMainBillingPage: {
    name: 'Can View current subscription information ( required for sub components of the billing section )',
    value: 'viewMainBillingPage',
    type: 'view',
    group: 'billing',
    currentlyUsed: false,
    hasChangeLog: false,
  },
  canUseSavedCardsForLicensePurchases: {
    name: 'Can use saved payment methods for license purchases',
    value: 'canUseSavedCardsForLicensePurchases',
    type: 'create',
    group: 'billing',
    currentlyUsed: false,
    hasChangeLog: true,
  },
  canAddPaymentMethods: {
    name: 'Can add payment methods',
    value: 'canAddPaymentMethods',
    type: 'create',
    group: 'billing',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  canEditPaymentMethods: {
    name: 'Can edit payment methods',
    value: 'canEditPaymentMethods',
    type: 'update',
    group: 'billing',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  canRemovePaymentMethods: {
    name: 'Can remove payment methods',
    value: 'canRemovePaymentMethods',
    type: 'delete',
    group: 'billing',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  canViewPaymentMethods: {
    name: 'Can View payment methods',
    value: 'canViewPaymentMethods',
    type: 'view',
    group: 'billing',
    currentlyUsed: false,
    hasChangeLog: false,
  },
  canChangeAutoPaySource: {
    name: 'Can change auto pay source',
    value: 'canChangeAutoPaySource',
    type: 'update',
    group: 'billing',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  canViewSettings: {
    name: 'Can View billing contacts',
    value: 'canViewSettings',
    type: 'view',
    group: 'billing',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  canAddContacts: {
    name: 'Can add billing contacts',
    value: 'canAddContacts',
    type: 'create',
    group: 'billing',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  canEditContacts: {
    name: 'Can edit billing contacts',
    value: 'canEditContacts',
    type: 'update',
    group: 'billing',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  canRemoveContacts: {
    name: 'Can remove billing contacts',
    value: 'canRemoveContacts',
    type: 'delete',
    group: 'billing',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  canChangePrimaryContact: {
    name: 'Can change primary billing contact',
    value: 'canChangePrimaryContact',
    type: 'update',
    group: 'billing',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  canAddLicenses: {
    name: 'Can add licenses',
    value: 'canAddLicenses',
    type: 'create',
    group: 'billing',
    currentlyUsed: true,
    hasChangeLog: true,
  },
};

export const UserViewRoles = {
  AddAllCurrentAndFutureUsersWithinDomain: {
    name: 'Can toggle domain-wide auto-enrollment for group membership',
    value: 'addAllCurrentAndFutureUsersWithinDomain',
    type: 'update',
    group: 'userView',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  EditEmailAddress: {
    name: 'Edit Email Addresses',
    value: 'editEmailAddress',
    type: 'update',
    group: 'userView',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  EditPhoneNumbers: {
    name: 'Edit Phone Numbers',
    value: 'editPhoneNumbers',
    type: 'update',
    group: 'userView',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  EditOrganizations: {
    name: 'Edit Organizations',
    value: 'editOrganizations',
    type: 'update',
    group: 'userView',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  EditRelationships: {
    name: 'Edit Relationships',
    value: 'editRelationships',
    type: 'update',
    group: 'userView',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  EditInstantMessaging: {
    name: 'Edit Instant Messaging',
    value: 'editInstantMessaging',
    type: 'update',
    group: 'userView',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  EditAddresses: {
    name: 'Edit Addresses',
    value: 'editAddresses',
    type: 'update',
    group: 'userView',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  EditExternalIds: {
    name: 'Edit External Ids',
    value: 'editExternalIds',
    type: 'update',
    group: 'userView',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  EditWebsites: {
    name: 'Edit Websites',
    value: 'editWebsites',
    type: 'update',
    group: 'userView',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  EditNotes: {
    name: 'Edit Notes',
    value: 'editNotes',
    type: 'update',
    group: 'userView',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  EditGender: {
    name: 'Edit Gender',
    value: 'editGender',
    type: 'update',
    group: 'userView',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  ViewCustomAttributes: {
    name: 'View Custom Attributes',
    value: 'viewCustomAttributes',
    type: 'view',
    group: 'userView',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  EditCustomAttributes: {
    name: 'Edit Custom Attributes',
    value: 'editCustomAttributes',
    type: 'update',
    group: 'userView',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  ViewAllGroups: {
    name: 'View All Groups',
    value: 'viewAllGroups',
    type: 'view',
    group: 'userView',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  CreateGroup: {
    name: 'Create Group',
    value: 'createGroup',
    type: 'create',
    group: 'userView',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  ViewSharedContacts: {
    name: 'View Shared Contacts',
    value: 'viewSharedContacts',
    type: 'view',
    group: 'userView',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  AddSharedContacts: {
    name: 'Add Shared Contacts',
    value: 'addSharedContacts',
    type: 'create',
    group: 'userView',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  EditSharedContacts: {
    name: 'Edit Shared Contacts',
    value: 'editSharedContacts',
    type: 'update',
    group: 'userView',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DeleteSharedContacts: {
    name: 'Delete Shared Contacts',
    value: 'deleteSharedContacts',
    type: 'delete',
    group: 'userView',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  ViewDirectorySearch: {
    name: 'View Directory Search',
    value: 'viewDirectorySearch',
    type: 'view',
    group: 'userView',
    currentlyUsed: true,
    hasChangeLog: false,
  },
};

export const GPanelContactsPermissions = {
  CanViewGPanelContacts: {
    name: 'Can View gPanel Contacts',
    value: 'canViewGPanelContacts',
    type: 'view',
    group: 'gPanelContacts',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  CreateContact: {
    name: 'Create Contact',
    value: 'createContact',
    type: 'create',
    group: 'gPanelContacts',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditContactDetails: {
    name: 'Edit Contact Details',
    value: 'editContactDetails',
    type: 'update',
    group: 'gPanelContacts',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  CreateGpanelLabels: {
    name: 'Create gPanel Labels',
    value: 'createGpanelLabels',
    type: 'create',
    group: 'gPanelContacts',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditGpanelLabels: {
    name: 'Edit gPanel Labels',
    value: 'editGpanelLabels',
    type: 'update',
    group: 'gPanelContacts',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  TrashGpanelLabels: {
    name: 'Trash gPanel Labels',
    value: 'trashGpanelLabels',
    type: 'trash',
    group: 'gPanelContacts',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ModifyGpanelContactLabelMembers: {
    name: 'Add/Remove Labels from gPanel Contacts',
    value: 'modifyGpanelContactLabelMembers',
    type: 'update',
    group: 'gPanelContacts',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewLogs: {
    name: 'View gPanel Contact Label Logs',
    value: 'viewLogs',
    type: 'view',
    group: 'gPanelContacts',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  ExportLabelLogs: {
    name: 'Export gPanel Label Logs',
    value: 'exportLabelLogs',
    type: 'create',
    group: 'gPanelContacts',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RecoverTrashedLabels: {
    name: 'Recover Trashed Labels',
    value: 'recoverTrashedLabels',
    type: 'create',
    group: 'gPanelContacts',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EmptyTrashedLabels: {
    name: 'Empty Trashed Labels',
    value: 'emptyTrashedLabels',
    type: 'purgeTrash',
    group: 'gPanelContacts',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  TrashContact: {
    name: 'Trash Contact',
    value: 'trashContact',
    type: 'trash',
    group: 'gPanelContacts',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ImportContacts: {
    name: 'Import Contacts',
    value: 'importContacts',
    type: 'create',
    group: 'gPanelContacts',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  RecoverTrashedContacts: {
    name: 'Recover Trashed Contacts',
    value: 'recoverTrashedContacts',
    type: 'create',
    group: 'gPanelContacts',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EmptyTrashedContacts: {
    name: 'Empty Trashed Contacts',
    value: 'emptyTrashedContacts',
    type: 'purgeTrash',
    group: 'gPanelContacts',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  ViewContactSyncs: {
    name: 'View Contact Syncs',
    value: 'viewContactSyncs',
    type: 'view',
    group: 'gPanelContacts',
    currentlyUsed: true,
    hasChangeLog: false,
  },
  CreateContactSync: {
    name: 'Create Contact Sync',
    value: 'createContactsSync',
    type: 'create',
    group: 'gPanelContacts',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  EditContactSync: {
    name: 'Edit Contact Sync',
    value: 'editContactsSync',
    type: 'update',
    group: 'gPanelContacts',
    currentlyUsed: true,
    hasChangeLog: true,
  },
  DeleteContactSync: {
    name: 'Delete Contact Sync',
    value: 'deleteContactsSync',
    type: 'delete',
    group: 'gPanelContacts',
    currentlyUsed: true,
    hasChangeLog: true,
  },
} as const satisfies Record<string, RoleConfig[string]>;

export function isAbleToSeeUIElement(roles: string[], uiRole: string): boolean {
  if (roles && Array.isArray(roles) && uiRole === 'viewVaultExports') {
    const granularVaultViewRoles = [
      'viewGmailVaultExport',
      'viewChatVaultExport',
      'viewGeminiVaultExport',
      'viewCalendarVaultExport',
      'viewDriveVaultExport',
      'viewGroupsVaultExport',
      'viewVaultMatters',
      'viewAllVault',
      'viewVaultExports',
    ];
    if (
      granularVaultViewRoles.some((role) => roles.includes(role)) ||
      roles.includes('*')
    ) {
      return true;
    }
  }
  return roles.includes(uiRole) || roles.includes('*');
}

export function hasPermission(
  permissions: string[],
  permission: string | null = null
): boolean {
  return permission !== null && isAbleToSeeUIElement(permissions, permission);
}
